"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterAndValidateV2GetScoreList = void 0;
const endpoints_1 = require("./endpoints");
/**
 * Use this function when pulling a list of scores from the database before returning to the public API to ensure type safety.
 * All scores are expected to pass the validation. If a score fails validation, it will be logged to Otel.
 * @param scores
 * @returns list of validated scores with optional trace information in case of trace scores
 */
const filterAndValidateV2GetScoreList = (scores, onParseError) => scores.reduce((acc, ts) => {
    const result = endpoints_1.GetScoreResponseDataV2.safeParse(ts);
    if (result.success) {
        acc.push(result.data);
    }
    else {
        console.error("Score parsing error: ", result.error);
        onParseError?.(result.error);
    }
    return acc;
}, []);
exports.filterAndValidateV2GetScoreList = filterAndValidateV2GetScoreList;
